import React, { useState } from 'react';

import { components } from '../../components';
import { hooks } from '../../hooks';
import { Routes } from '../../routes';
import { MenuType } from '../../types';

export const Menu: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  const {menuLoading, menu} = hooks.useGetMenu();

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderMenu = (): JSX.Element => {
    return (
      <section style={{
        paddingTop: 20,
        paddingBottom: 20,
      }}>
        <ul
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            margin: 0,
            padding: '0 20px',
            listStyle: 'none',
          }}
        >
          {menu.map((menu: MenuType) => {
            return (
              <li
                key={menu.id}
                className='clickable'
                style={{
                  position: 'relative',
                  borderRadius: 16,
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  navigate(Routes.MenuList, {state: {menuName: menu.name}})
                }
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                }}
              >
                <img
                  src={menu.image}
                  alt={menu.name}
                  style={{
                    borderRadius: 16,
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    aspectRatio: '1 / 1',
                    objectFit: 'cover',
                  }}
                />
                <div style={{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  right: 0,
                  background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)',
                  padding: '20px 16px 12px',
                }}>
                  <span
                    className='t16 number-of-lines-1'
                    style={{
                      color: '#fff',
                      fontWeight: 600,
                      fontSize: 15,
                      textShadow: '0 1px 3px rgba(0,0,0,0.8)',
                      fontFamily: 'DM Sans, sans-serif',
                    }}
                  >
                    {menu.name}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </section>
    );
  };

  const renderContent = (): JSX.Element | null => {
    if (menuLoading && !menu.length) return null;
    return <main className='scrollable container'>{renderMenu()}</main>;
  };

  const renderLoader = (): JSX.Element | null => {
    if (menuLoading) return <components.Loader />;
    return null;
  };
const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        title='Categories'
      />
    );
  };
  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderLoader()}
      {renderContent()}
    </div>
  );
};
